module.exports = __webpack_public_path__ + "static/media/crab.fc7d165f.jpg";